import React from 'react';
import { Image } from 'antd';

export default function LogoWithVersion({ imageHeight = 65 }) {
  const appVersion = process.env.REACT_APP_VERSION;

  return (
    <>
      <Image
        style={{ height: `${imageHeight}px`, width: 'auto' }}
        src="/logo_txt_white_bg.png"
        preview={false}
      />
      {appVersion && (
        <div style={{ marginTop: 8, color: '#595959', fontSize: 12 }}>
          {appVersion}
        </div>
      )}
    </>
  );
}
